import Form from '@/app/components/UI/Form'
import Head from 'next/head'

export default function ContactPartsPage() {
  return (
    <>
      <Head>
        <title>Azul Agro - Contato de Peças</title>
        <meta name="description" content="Entre em contato com a Azul Agro para tirar suas dúvidas sobre peças, solicitar informações ou receber suporte técnico. Estamos prontos para ajudar você a manter suas operações agrícolas em pleno funcionamento com nossas peças de alta qualidade." />
      </Head>
      <main>
        <Form parts />
      </main>
    </>
  )
}
